module.exports = __webpack_public_path__ + "img/nasi-goreng-telor.06546276.jpg";